import React from 'react'
import { Box, Link, styled, Typography } from '@mui/material'
import { TruncateText } from './../../../utils/TruncateText';

const MainBox = styled(Box)(({ theme }) => ({
  width: '45vw',
  borderLeft: '7px solid #55d6aa',
  //mobile screen
  [theme.breakpoints.down("md")]: {
    width: '85vw',
    borderLeft: '4px solid #55d6aa',
    
  },
}));

const TitleTypography = styled(Typography)(({ theme }) => ({
  padding: '0.5rem',
  paddingLeft: '2.5rem',
  fontSize: '1rem',
  color: '#242424', 
  //mobile screen
  [theme.breakpoints.down("sm")]: {
    paddingLeft: '1rem',
    fontSize: '0.8rem',
    
  },
}));

const TagsBox = styled(Box)(({ theme }) => ({
  padding: '0.5rem',
  paddingLeft: '2.5rem',
  color: '#242424',
  //mobile screen
  [theme.breakpoints.down("sm")]: {
    paddingLeft: '1rem',
  },
}));

function CompanyProfileSectionCard({ companyProfile }) {

  const truncatedTitle = TruncateText(companyProfile.title, 150);

  return (
    <MainBox>
      <TitleTypography variant='h5' >{truncatedTitle}</TitleTypography>
      <TagsBox sx={{ display: 'flex', justifyContent: 'space-between', p: 1, pl: 5 }} >
        <Typography sx={{ fontSize: { xs: '0.8rem', md: '1rem' } }} >{companyProfile.category}</Typography>
        <Typography sx={{ fontSize: { xs: '0.8rem', md: '1rem' } }} >{companyProfile.publishDate}</Typography>
      </TagsBox>
    </MainBox>
  )
}

export default CompanyProfileSectionCard
